
    let intervalID = -1;
    import $ from 'jquery'
    import { defineComponent } from 'vue';
    import {ImageData} from '../Classes/Interfaces'
    type DataReturn = {
        Index:number,
        PageRate:number,
        doTick:boolean,
        FileInfo:ImageData[]
    }

    export default defineComponent({
        name:"carouselComp",
        data:function():DataReturn{
            return {
                Index: 0,
                PageRate:3000,
                doTick:true,
                FileInfo:[]
            }
        },
        components:{},
        props:["PageRateIn"],
        methods:{
            mouseEnter:function()
            {
                this.doTick = false;
            },
            mouseLeave:function(){
                this.doTick = true;
            },
            getData:function()
            {
                // eslint-disable-next-line
                let vm = this;
                $.getJSON("/Data/Data.json",
                    function (data) {
                        vm.FileInfo = data.ImageData
                        vm.FileInfo = vm.FileInfo.filter(function(e){
                            return !e.Tags.includes("Portrait")
                        })
                        clearInterval(intervalID)
                        intervalID = setInterval(vm.tick,vm.PageRate)

                        vm.loadData()
                    }
                );
            },
            
            loadData: function() {  
                $(".carouselDisplay").css("background-image",`url('${this.FileInfo[this.Index].ImagePath}')`);
                $(".carouselTextHolder").html(`
                <p class="carouselText">${this.FileInfo[this.Index].Description}</p>
                `)
            },
            tick: function() {
                // console.log(this.doTick)
                if (!this.doTick)
                    return;
                this.btnRightClick()
                this.loadData()
            },
            btnRightClick: function() {
                this.Index++;
                if (this.Index >= this.FileInfo.length)
                    this.Index = 0
                this.loadData()
            },
            btnLeftClick: function() {
                this.Index--;
                if (this.Index < 0)
                    this.Index = this.FileInfo.length-1
                this.loadData()
            }
        },
        created:function(){
            this.PageRate = this.PageRateIn;
            console.log('Created Carousel')
            $(".carouselHolder").mouseenter(this.mouseEnter);
            this.getData();
        }
    })
